import OrgLookupInput from "./OrgLookupInput";
import { useOrgExperience } from "@shared/hooks/useOrgExperience";
import Select from "./Select";

type Props = {
  namePrefix: string;
};

export function OrgLookupYearComboInput({ namePrefix }: Props) {
  const {
    handleSelectOrganization,
    handleCreateOrganization,
    options,
    isLoading,
  } = useOrgExperience();

  const maxYear = new Date().getFullYear() + 4;

  const years = Array.from({ length: 71 }, (_, i) => (maxYear - i).toString());

  const yearOptions = years.map((year) => ({
    label: year,
    value: year,
  }));

  return (
    <div className="flex flex-col items-end gap-2 md:flex-row">
      <OrgLookupInput
        name={`${namePrefix}.organization`}
        onSelect={handleSelectOrganization}
        onCreate={handleCreateOrganization}
        options={options}
        isLoading={isLoading}
        className="px-0 flex-1"
      />

      <Select
        name={`${namePrefix}.year`}
        options={yearOptions}
        placeholder="Year attended"
        className="w-full md:w-auto"
        required
        disabled={isLoading}
      />
    </div>
  );
}

export default OrgLookupYearComboInput;
